var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: "",
                    "label-width": _vm.isZh ? "80px" : "145px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Parter") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": _vm.cmpIdxMethodParams,
                          "callback-method-type": "value",
                          "default-value": _vm.searchForm.cmpIdx || "",
                          "callback-params": { key: "cmpIdx" },
                          no: "1"
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessTypeP") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { no: "2" },
                          on: { change: _vm.busTypeChangeHandler },
                          model: {
                            value: _vm.searchForm.busType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "busType", $$v)
                            },
                            expression: "searchForm.busType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_All"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Customer"),
                              value: "customer"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_BookingAgent"),
                              value: "bookingAgent"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_DestinationAgent"),
                              value: "overseaAgent"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_NominatedAgent"),
                              value: "designationAgent"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_LocalAgent"),
                              value: "localAgent"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CarrierShip"),
                              value: "seaCmp"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AirlineCompany"),
                              value: "airCmp"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CustomsBroker"),
                              value: "customsBroker"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_TruckCompany"),
                              value: "truckCmp"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Warehouse"),
                              value: "warehouse"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_GroupCompany"),
                              value: "global"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Shipper"),
                              value: "shipper"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Consignee"),
                              value: "consignee"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_NotifyParty"),
                              value: "notify"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_SalesP") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "method-params": {
                            active: true,
                            category: "role",
                            shape: "sales"
                          },
                          "callback-method-type": "value",
                          "default-value": _vm.searchForm.sales || "",
                          "callback-params": { key: "sales" },
                          no: "3"
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PaymentPeriodRange")
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          min: 0,
                          max: 9999999,
                          precision: 0,
                          "controls-position": "right",
                          no: "4"
                        },
                        model: {
                          value: _vm.searchForm.creditTermMin,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "creditTermMin", $$v)
                          },
                          expression: "searchForm.creditTermMin"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "0 2px" } }, [
                        _vm._v("-")
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "80px", "margin-right": "2px" },
                        attrs: {
                          min: 0,
                          max: 9999999,
                          precision: 0,
                          "controls-position": "right",
                          no: "5"
                        },
                        model: {
                          value: _vm.searchForm.creditTermMax,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "creditTermMax", $$v)
                          },
                          expression: "searchForm.creditTermMax"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "50px" },
                          attrs: { no: "6" },
                          model: {
                            value: _vm.searchForm.termUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "termUnit", $$v)
                            },
                            expression: "searchForm.termUnit"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Days"),
                              value: "0"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Week"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Month"),
                              value: "2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CreditLimitRange")
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          min: 0,
                          max: 9999999,
                          precision: 0,
                          "controls-position": "right",
                          no: "7"
                        },
                        model: {
                          value: _vm.searchForm.creditMin,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "creditMin", $$v)
                          },
                          expression: "searchForm.creditMin"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "0 2px" } }, [
                        _vm._v("-")
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "80px", "margin-right": "2px" },
                        attrs: {
                          min: 0,
                          max: 9999999,
                          precision: 0,
                          "controls-position": "right",
                          no: "8"
                        },
                        model: {
                          value: _vm.searchForm.creditMax,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "creditMax", $$v)
                          },
                          expression: "searchForm.creditMax"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "60px" },
                          attrs: { no: "9" },
                          model: {
                            value: _vm.searchForm.currency,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "currency", $$v)
                            },
                            expression: "searchForm.currency"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_All"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: { label: "RMB", value: "RMB" }
                          }),
                          _c("el-option", {
                            attrs: { label: "USD", value: "USD" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SettlementType") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { no: "10" },
                          model: {
                            value: _vm.searchForm.settlementType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "settlementType", $$v)
                            },
                            expression: "searchForm.settlementType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_All"),
                              value: "0"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SettlementByBill"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_SettlementNotByBill"
                              ),
                              value: "2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Blacklist") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { no: "11" },
                          model: {
                            value: _vm.searchForm.blacklist,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "blacklist", $$v)
                            },
                            expression: "searchForm.blacklist"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: "0"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PaymentPeriodExceeded")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { no: "12" },
                          model: {
                            value: _vm.searchForm.dateExceeded,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "dateExceeded", $$v)
                            },
                            expression: "searchForm.dateExceeded"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: "0"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CreditLimitExceeded")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { no: "13" },
                          model: {
                            value: _vm.searchForm.amountExceeded,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "amountExceeded", $$v)
                            },
                            expression: "searchForm.amountExceeded"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: "0"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ETDExceeded") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { no: "22" },
                          model: {
                            value: _vm.searchForm.etdExceeded,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "etdExceeded", $$v)
                            },
                            expression: "searchForm.etdExceeded"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: "0"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_TempCredit") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { no: "14" },
                          model: {
                            value: _vm.searchForm.tempCredit,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "tempCredit", $$v)
                            },
                            expression: "searchForm.tempCredit"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: "0"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_WhetherIgnore") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "116px" },
                          attrs: { no: "15" },
                          model: {
                            value: _vm.searchForm.whetherIgnoreCharge,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.searchForm,
                                "whetherIgnoreCharge",
                                $$v
                              )
                            },
                            expression: "searchForm.whetherIgnoreCharge"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: "1"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: "0"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMPP") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { no: "14" },
                          model: {
                            value: _vm.searchForm.branchId,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "branchId", $$v)
                            },
                            expression: "searchForm.branchId"
                          }
                        },
                        _vm._l(_vm.offices, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                (_vm.isZh
                                  ? item.chineseName
                                  : item.englishName) || " ",
                              value: item.officeId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "15" },
                          on: { click: _vm.searchHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                      ),
                      !_vm.isZy &&
                      _vm.$checkPermission([
                        "button_tabSettleAccountList_blacklist"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "16" },
                              on: { click: _vm.onBlacklist }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.blacklistLabel ||
                                    _vm.$t("CargoMsg.Cargo_AddToBlackList")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "21" },
                          on: { click: _vm.onRefresh }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "23" },
                          on: { click: _vm.onRefreshCreditControl }
                        },
                        [_vm._v("刷新信控")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "17" },
                          on: { click: _vm.resetClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter")))]
                      ),
                      _c("span", { staticStyle: { "margin-left": "5px" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_HasChosen") +
                              ":" +
                              _vm.currentCreditName
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  no: "18"
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  no: "19"
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              })
            ],
            1
          )
        ]),
        _c("credit-control-setting-dialog", {
          attrs: {
            visible: _vm.creditControlSettingDialogVisible,
            "current-credit": _vm.currentCredit,
            company: _vm.company,
            no: "20"
          },
          on: {
            "update:visible": function($event) {
              _vm.creditControlSettingDialogVisible = $event
            },
            handleSaved: function($event) {
              return _vm.handleSaved()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }